import React from 'react';
import type { PackageVehicleReason } from '@/types/package';
import { describePackageVehicleReason } from './packageVehicleReasons';

export interface PackageVehicleReasonListProps {
  reasons: PackageVehicleReason[];
  /** `warning` for reasons ops is about to waive, `muted` for plain facts. */
  tone?: 'warning' | 'muted';
  /** Prefix such as "Aturan 2" for a reason's rule; null hides it. */
  ruleLabel?: (ruleID?: string) => string | null;
  id?: string;
  className?: string;
}

/** Why a unit is not a package's stock, one sentence per reason. */
export const PackageVehicleReasonList: React.FC<
  PackageVehicleReasonListProps
> = ({ reasons, tone = 'muted', ruleLabel, id, className = '' }) => {
  if (reasons.length === 0) return null;
  const isWarning = tone === 'warning';
  return (
    <ul
      id={id}
      className={`space-y-0.5 text-[12px] ${
        isWarning ? 'text-[#FA7319]' : 'text-gray-600'
      } ${className}`}
    >
      {reasons.map((reason, i) => {
        const rule = ruleLabel?.(reason.ruleID);
        return (
          <li key={i} className="flex gap-1">
            <i
              aria-hidden="true"
              className={`leading-4 ${
                isWarning
                  ? 'ri-error-warning-line'
                  : 'ri-close-circle-line text-gray-400'
              }`}
            ></i>
            <span>
              {rule && <span className="font-medium">{rule}: </span>}
              {describePackageVehicleReason(reason)}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
